var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.disableLayout === false
      ? _c(
          "div",
          { staticClass: "reports-page" },
          [
            _c(
              "layout-primary",
              {
                attrs: {
                  "title-text": _vm.reportTitle,
                  "disable-spinner": _vm.disableSpinner
                }
              },
              [
                _c("div", {
                  class: { "tooltip-overlay": _vm.showToolTip },
                  attrs: { title: _vm.reportToolTip }
                }),
                _c("div", { staticClass: "reports-page__container" }, [
                  _vm.showReportTitle
                    ? _c("div", { staticClass: "custom-report-title-header" }, [
                        _c(
                          "div",
                          { staticClass: "custom-report-title-section" },
                          [
                            _c("span", { staticClass: "custom-report-title" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm._f("addReportText")(_vm.reportTitle)
                                  ) +
                                  "\n                        "
                              )
                            ]),
                            _c(
                              "div",
                              { staticClass: "report-command-btn-section" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "report-command-btn",
                                    attrs: {
                                      id: "DownloadReportExcel",
                                      value: "Download",
                                      title: _vm.downloadToolTip,
                                      disabled: _vm.downloadDisabled
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.downloadReportClick($event)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                Download\n                            "
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.oneWarehouseSelected,
                          expression: "!oneWarehouseSelected"
                        }
                      ],
                      staticClass: "resizer"
                    },
                    [
                      _c("spinner", {
                        staticClass: "report-spinner",
                        attrs: { active: _vm.loading }
                      }),
                      _vm.customLoader
                        ? _c("div", { staticClass: "custom-loader-wrapper" }, [
                            _c("div", { staticClass: "custom-loader" })
                          ])
                        : _vm._e(),
                      _c("section", {
                        staticClass: "section-class",
                        attrs: {
                          id: "report-container-" + _vm.reportType,
                          title: _vm.reportToolTip
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.oneWarehouseSelected,
                          expression: "oneWarehouseSelected"
                        }
                      ],
                      staticClass: "one-warehouse-selected"
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: "/favicon/one-warehouse-selected-wh.svg",
                          alt: "Only one warehouse selected"
                        }
                      })
                    ]
                  )
                ])
              ]
            )
          ],
          1
        )
      : _c("div", { staticClass: "reports-page-custom" }, [
          _c("div", {
            class: { "tooltip-overlay": _vm.showToolTip },
            attrs: { title: _vm.reportToolTip }
          }),
          _c("div", { staticClass: "reports-page-custom__container" }, [
            _vm.reportTitleVisible
              ? _c("div", { staticClass: "report-title-header" }, [
                  _c("p", { staticClass: "report-title" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.reportTitle) +
                        "\n                "
                    )
                  ])
                ])
              : _vm._e(),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.oneWarehouseSelected,
                    expression: "!oneWarehouseSelected"
                  }
                ],
                staticClass: "resizer"
              },
              [
                _vm.disableSpinner === false
                  ? _c("spinner", {
                      staticClass: "report-spinner-custom",
                      attrs: { active: _vm.loading }
                    })
                  : _vm._e(),
                _vm.customLoader
                  ? _c("div", { staticClass: "custom-loader-wrapper" }, [
                      _c("div", { staticClass: "custom-loader" })
                    ])
                  : _vm._e(),
                _c("section", {
                  staticClass: "section-class",
                  attrs: {
                    id: "report-container-" + _vm.reportType,
                    title: _vm.reportToolTip
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.oneWarehouseSelected,
                    expression: "oneWarehouseSelected"
                  }
                ],
                staticClass: "one-warehouse-selected"
              },
              [
                _c("img", {
                  attrs: {
                    src: "/favicon/one-warehouse-selected-wh.svg",
                    alt: "Only one warehouse selected"
                  }
                })
              ]
            )
          ])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }